// src/config/freemium.js — Limites compte freemium

export const FREEMIUM_PROS_LIMIT = 2;

export function isProAccessBlocked(user, itemsPro, jobId) {
  return (
    !user.is_premium &&
    Object.keys(itemsPro).length >= FREEMIUM_PROS_LIMIT &&
    itemsPro[jobId] === undefined
  );
}
